<template>
  <div>
    <b-row align-v="center" class="mt-3">
        <b-col md="12">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb bg-primary w-100">
              <li class="breadcrumb-item active text-white" aria-current="page">GENERAL INFORMATION</li>
            </ol>
          </nav>
        </b-col>
        <b-col md="12" class="text-center mb-4">
          <template v-for="(item, index) in fleetCategory">
            <b-form-radio
              v-model="formFleet.vehicleTypeId"
              class="custom-radio-color-checked"
              inline
              :color="item.color"
              name="color"
              :key="index"
              :value="item.value"
              :disabled="item.disabled"
              >{{ item.label }}</b-form-radio
            >
          </template>
        </b-col>
        <b-form-group class="col-md-3" label="Fleet Name *" label-for="fleet_name">
            <b-form-input v-model="formFleet.name" type="text"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-3" label="Fleet Code *" label-for="fleet_code">
            <b-form-input v-model="formFleet.code" type="text"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-3" label="Company Name *" label-for="company_name">
            <b-form-select plain v-model="formFleet.companyId" :options="CompanyName" :reduce="CompanyName => CompanyName.value" size="lg">
              <template v-slot:first>
                <b-form-select-option :value="null">Select Company Name</b-form-select-option>
              </template>
            </b-form-select>
        </b-form-group>
        <b-form-group class="col-md-3" label="Ownership *" label-for="contract">
            <b-form-select plain v-model="formFleet.ownership" :options="Contract" size="lg">
              <template v-slot:first>
                <b-form-select-option :value="null">Select Contract</b-form-select-option>
              </template>
            </b-form-select>
        </b-form-group>
        <b-form-group class="col-md-2" label="Technical Module" label-for="technical_module">
            <template v-for="(item,index) in technical">
              <b-form-radio inline v-model="technicalActive[item[Object.keys(item)[0]]]" :name="item.name" :key="index" :value="item.value" :disabled="item.disabled">{{ item.label }}</b-form-radio>
            </template>
        </b-form-group>
        <b-form-group class="col-md-2" label="Latitude" label-for="id_gps">
          <b-form-input type="text" v-model="formFleet.latitude"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-2"  label="Longitude" label-for="id_gps">
          <b-form-input type="text" v-model="formFleet.longitude"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-3" label="Flag *" label-for="fleet_name">
          <b-form-input type="text"  v-model="formFleet.flag"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-3" label="Year Build & Country" label-for="fleet_code">
          <b-form-input type="text" v-model="formFleet.yearBuildCountry"></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-6" label="Picture of Fleet" label-for="fleet_code">
          <b-form-file
          id="fileSupport"
          placeholder="Choose a file"
          accept=".jpg, .png, .gif, .jpeg, .svg"
          :disabled="loading_upload_file"
          @change="uploadFilePhoto"></b-form-file>
          <p class="mt-2 text-danger" v-if="loading_upload_file"
          >Please wait, uploading file is in process...</p
          >
          <span v-if="editMode">{{formFleet.img}}</span>
        </b-form-group>
<!--                        <b-form-group class="col-md-2" label="Barge Limit" label-for="barge_limit">
            <b-form-input type="number"></b-form-input>
        </b-form-group>-->
        <b-form-group class="col-md-3" label="ID GPS" label-for="id_gps">
            <b-form-input v-model="formFleet.idGps" type="number"></b-form-input>
        </b-form-group>
        <b-form-group class="col-sm-3" label="Delivery Date" label-for="delivery_date">
          <b-form-input v-model="formFleet.deliveryDate"  type="date" id="deliveryDate"></b-form-input>
          <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
        </b-form-group>
        <b-form-group class="col-sm-6" label="Classification" label-for="classification">
          <b-form-textarea v-model="formFleet.classification" name="Classification" style="line-height: 22px;" rows="5">
          </b-form-textarea>
        </b-form-group>
        <b-form-group class="col-sm-6" label="Basic Function" label-for="basic_function">
          <b-form-textarea v-model="formFleet.basicFunction" name="Basic Function" style="line-height: 22px;" rows="5">
          </b-form-textarea>
        </b-form-group>

        <b-col md="12">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb bg-primary w-100">
              <li class="breadcrumb-item active text-white" aria-current="page">DIMENSION</li>
            </ol>
          </nav>
        </b-col>

        <b-col md="12">
          <table class="table mb-0 table-borderless table-box-shadow">
            <thead>
            <tr>
              <th width="50%">Dimensions</th>
              <th width="25%">Feet</th>
              <th width="25%">Meters</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><h5>Length</h5></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.length.feet" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">Ft</span>
                </div>
              </div></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.length.meter" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">M</span>
                </div>
              </div></td>
            </tr>
            <tr>
              <td><h5>Width</h5></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.width.feet" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">Ft</span>
                </div>
              </div></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.width.meter" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">M</span>
                </div>
              </div></td>
            </tr>
            <tr>
              <td><h5>Depth</h5></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.depth.feet" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">Ft</span>
                </div>
              </div></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.depth.meter" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">M</span>
                </div>
              </div></td>
            </tr>
            <tr>
              <td><h5>Draft</h5></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.draft.feet" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">Ft</span>
                </div>
              </div></td>
              <td><div class="input-group">
                <b-form-input v-model="formFleet.dimension.draft.meter" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">M</span>
                </div>
              </div></td>
            </tr>
            <tr>
              <td><h5>Speed</h5></td>
              <td colspan="2"><div class="input-group">
                <b-form-input v-model="formFleet.dimension.speed" type="number"></b-form-input>
                <div class="input-group-prepend">
                  <span class="input-group-text">Knots</span>
                </div>
              </div></td>
            </tr>
            </tbody>
          </table>
        </b-col>

        <b-col md="12">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb bg-primary">
              <li class="breadcrumb-item active text-white" aria-current="page">POWER</li>
            </ol>
          </nav>
        </b-col>

        <b-col md="12" v-if="formPower.typeOfPower.length > 0">
          <table class="table mb-0 table-borderless table-box-shadow">
            <thead>
            <tr>
              <th width="35%">Type of Power</th>
              <th width="35%">Series</th>
              <th width="20%">Actual Running Hours</th>
              <th width="10%">#</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(power, index) in formPower.typeOfPower" :key="index">
              <td>
                <v-select label="text" v-model="power.powerTypeId" :options="powerOptions" :reduce="powerOptions => powerOptions.value"></v-select>
              </td>
              <td>
                <v-select label="text" v-model="power.powerSeriesId" :options="main_engine" :reduce="main_engine => main_engine.value"></v-select>
              </td>
              <td>
                <div class="input-group">
                  <b-form-input v-model="power.actualRunningHours" type="number"></b-form-input>
                  <div class="input-group-prepend">
                    <span class="input-group-text">H</span>
                  </div>
                </div>
              </td>
              <td>
                <template v-if="formPower.typeOfPower.length > 1">
                  <b-button @click.prevent="removePower(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
          <b-button variant="warning" block class="mt-2 mb-3" @click.prevent="addPower()"><i class="fa fa-plus"></i> Add More Type of Power</b-button>
        </b-col>

        <b-col md="12">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb bg-primary">
              <li class="breadcrumb-item active text-white" aria-current="page">ROB TYPE</li>
            </ol>
          </nav>
        </b-col>
        <b-col md="12">
          <table class="table mb-0 table-borderless table-box-shadow">
            <thead>
            <tr>
              <th width="35%">Type</th>
              <th width="35%">Series</th>
              <th width="20%" v-if="!editMode">Actual ROB</th>
              <th width="10%">#</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(rob, index) in formROBType.typeOfROB" :key="index">
              <td>
                <v-select label="text" v-model="rob.robTypeId" :options="ROBOptions" :reduce="ROBOptions => ROBOptions.value"></v-select>
              </td>
              <td>
                <v-select label="text" v-model="rob.robSeriesId" :options="seriesROBOptions" :reduce="seriesROBOptions => seriesROBOptions.value"></v-select>
              </td>
              <td  v-if="!editMode">
                <div class="input-group">
                  <b-form-input v-model="rob.actualRob" type="number"></b-form-input>
                  <div class="input-group-prepend">
                    <span class="input-group-text">H</span>
                  </div>
                </div>
              </td>
              <td>
                <template v-if="formROBType.typeOfROB.length > 1">
                  <b-button @click.prevent="removeROBType(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
          <b-button variant="warning" block class="mt-2 mb-3" @click.prevent="addROBType()"><i class="fa fa-plus"></i> Add More Type</b-button>
        </b-col>

        <b-col md="12">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb bg-primary">
              <li class="breadcrumb-item active text-white" aria-current="page">FILE / DOCUMENT SUPPORT FOR THIS FLEET/EQUIPMENT</li>
            </ol>
          </nav>
        </b-col>

        <b-col cols="12" md="12" v-if="formFileSupportList.fileSupport.length > 0">
          <table class="table mb-0 table-borderless table-box-shadow">
            <thead>
            <tr>
              <th width="5%">No.</th>
              <!-- <th width="50%">Name of File / Document</th> -->
              <th width="35%">File / Document</th>
              <th width="10%">#</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(fileSupport, index) in formFileSupportList.fileSupport" :key="index">
              <td>{{index+1}}</td>
              <!-- <td><b-form-input type="text" v-model="fileSupport.fileName" placeholder="Name of File / Document Support"></b-form-input></td> -->
              <td>
                <b-form-file
                :id="'fileDocs'+index"
                placeholder="Choose a file"
                accept=".pdf, .docx"
                :disabled="formFileSupportList.fileSupport[index].isUploading"
                @change="uploadFileDoc($event,index)"></b-form-file>
                <p class="mt-2 text-danger" v-if="formFileSupportList.fileSupport[index].isUploading"
                >Please wait, uploading file is in process...</p
                >
                <span v-if="editMode">{{fileSupport.fileName}}</span>
                </td>
              <td>
                <template v-if="formFileSupportList.fileSupport.length > 1">
                  <b-button @click.prevent="removeFileSupportList(index)" size="sm" variant="danger" class="mb-3 mr-1"><i class="fa fa-trash"></i></b-button>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
          <b-button variant="warning" block class="mt-2 mb-3" @click.prevent="addFileSupportList()"><i class="fa fa-plus"></i> Add More File Support</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" class="text-right">
          <b-card-text
            ><small class="text-muted"
              >Sign * :
              <b-badge variant="warning"
                >Mandatory (Must be Input)</b-badge
              ></small
            ></b-card-text
          >
          <b-button type="submit" @click.prevent="saveFleet()" variant="primary" class="mr-2 text-right"
            >Submit</b-button
          >
          <b-button type="reset" @click.prevent="initFormFleet()" variant="none" class="iq-bg-danger text-right"
            >Reset</b-button
          >
        </b-col>
      </b-row>
  </div>
</template>

<script>
import appConfig from '@src/app.config';
import dayjs from 'dayjs'
import { fleetsActions, companiesActions, powerActions, robActions, filesActions } from '@state/helpers';

export default {
  page: {
    title: 'AddFleet',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      editMode: false,
      selected: ['select-1'],
      fleetCategory: [],
      technicalActive: {
        technical_module: true
      },
      formPower: {
        _saving: false,
        typeOfPower: []
      },
      loading_upload_file: false,
      powerOptions: [],
      ROBOptions: [],
      seriesROBOptions: [],
      formROBType: {
        _saving: false,
        typeOfROB: []
      },
      technical: [
        {
          name: 'technical_module',
          label: 'Yes',
          value: true,
          disabled: false
        },
        {
          name: 'technical_module',
          label: 'No',
          value: false,
          disabled: false
        }
      ],
      main_engine: [],
      CompanyName: [],
      Contract: [
        { value: 'OWNED', text: 'Owned by Company' },
        { value: 'CHARTERED', text: 'Chartered' }
      ],
      formFileSupportList: {
        _saving: false,
        fileSupport: []
      },
      formFleet: {
        name: '',
        code: '',
        horsePower: null,
        idGps: '',
        deliveryDate: '',
        classification: '',
        basicFunction: '',
        ownership: '',
        companyId: null,
        vehicleTypeId: 1,
        technical: false,
        latitude: null,
        longitude: null,
        flag: '',
        yearBuildCountry: '',
        img: null,
        dimension: {
          length: {
              feet: '',
              meter: ''
          },
          width: {
              feet: '',
              meter: ''
          },
          depth: {
              feet: '',
              meter: ''
          },
          draft: {
              feet: '',
              meter: ''
          },
          speed: ''
        },
        powers: [],
        robs: [],
        docs: []
      }
    }
  },
  props: {
      formData: {
          default: null,
          type: Object,
          required: false
      },
      isAddForChild: {
          default: false,
          type: Boolean,
          required: false
      },
  },
  
  async mounted() {
    if(this.formData) {
      this.editMode = true;
    }
    await this.getVehicleTypeData();
    await this.getCompanyListData();
    await this.getPowerData();
    await this.getRobData();
    this.initFormFleet();
  },
  methods: {
  ...fleetsActions,
  ...companiesActions,
  ...powerActions,
  ...robActions,
  ...filesActions,
    addPower () {
      this.formPower.typeOfPower.push(
        {
          powerTypeId: null,
          powerSeriesId: null,
          actualRunningHours: null
        }
      )
    },
    removePower (index) {
      this.formPower.typeOfPower.splice(index, 1)
    },
    addROBType () {
      let dataAdd = {
          robTypeId: null,
          robSeriesId: null,
          actualRob: null
      }
      if(this.editMode) delete dataAdd.actualRob
      this.formROBType.typeOfROB.push(dataAdd)
    },
    removeROBType (index) {
      this.formROBType.typeOfROB.splice(index, 1)
    },
    addFileSupportList () {
      this.formFileSupportList.fileSupport.push(
        {
          fileName: '',
          isUploading: false
        }
      )
    },
    removeFileSupportList (index) {
      this.formFileSupportList.fileSupport.splice(index, 1)
    },
    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

        if (res.status == 'success' && res.data && res.data.length > 0) {
          res.data.forEach(element => {
            if(element.active) {
              this.fleetCategory.push({
                label: element.name,
                color: element.name === 'Tugboat' ? 'success' : (element.name === 'Barge' ?'warning' :' primary'),
                value: element.id,
              })
            }
          });
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getCompanyListData() {
      const res = await this.getCompanies()

        if (res.status == 'success' && res.data && res.data.length > 0) {
          res.data.forEach(element => {
              this.CompanyName.push({
                text: `${element.company} - ${element.location}`,
                value: element.id,
              })
          });
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }
    },
    async getPowerData() {
      let paramsQ = {
        page: 1,
        search: '',
        active: true
      }
      const res = await this.getPowerTypes({params: paramsQ})

        if (res.status == 'success') {
          if(res.data && res.data.length > 0) {
            res.data.forEach(element => {
                this.powerOptions.push({
                  text: element.name,
                  value: element.id,
                })
            });
          }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }

        const res2 = await this.getPowerSeries({params: paramsQ})

        if (res2.status == 'success') {
          if(res2.data && res2.data.length > 0) {
            res2.data.forEach(element => {
                this.main_engine.push({
                  text: `${element.name} - ${element.model}`,
                  value: element.id,
                })
            });
          }
        } else {
          this.$swal(
            `Oops!`,
            res2.data,
            'error'
          )
        }
    },
    async getRobData() {
      let paramsQ = {
        page: 1,
        search: '',
        active: true
      }
      const res = await this.getRobTypes({params: paramsQ})

        if (res.status == 'success' ) {
          if(res.data && res.data.length > 0) {
            res.data.forEach(element => {
                this.ROBOptions.push({
                  text: element.name,
                  value: element.id,
                })
            });
          }
        } else {
          this.$swal(
            `Oops!`,
            res.data,
            'error'
          )
        }

        const res2 = await this.getRobSeries({params: paramsQ})

        if (res2.status == 'success' ) {
          if(res2.data && res2.data.length > 0) {
            res2.data.forEach(element => {
                this.seriesROBOptions.push({
                  text: `${element.series} - ${element.manufacturer}`,
                  value: element.id,
                })
            });
          }
        } else {
          this.$swal(
            `Oops!`,
            res2.data,
            'error'
          )
        }
    },
    async uploadFilePhoto (event) {
      this.loading_upload_file = true

      const files = [...event.target.files]
      let file = files[0]

      let formData = new FormData()
      formData.append('file', file)

      let res = await this.upload(formData)
      if (res.status == 'success') {
        this.loading_upload_file = false
        this.formFleet.img = res.data.fileName
      } else {
        this.loading_upload_file = false
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }
    },
    async uploadFileDoc(event, i) {
      this.formFileSupportList.fileSupport[i].isUploading = true;

      const files = [...event.target.files]
      let file = files[0]

      let formData = new FormData()
      formData.append('file', file)

      let res = await this.upload(formData)
      if (res.status == 'success') {
        this.formFileSupportList.fileSupport[i].isUploading = false
        this.formFileSupportList.fileSupport[i].fileName = res.data.fileName
      } else {
        this.formFileSupportList.fileSupport[i].isUploading = false
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }
    },
    cancelFromParent() {
      this.$emit("childAction", true);
    },
    initFormFleet() {
      this.formFleet = {
        name: '',
        code: '',
        horsePower: null,
        idGps: '',
        deliveryDate:  '',
        classification:  '',
        basicFunction: '',
        ownership: '',
        companyId: null,
        vehicleTypeId:  1,
        technical: false,
        latitude:  null,
        longitude:  null,
        flag: '',
        yearBuildCountry:  '',
        img:  null,
        dimension: {
          length: {
              feet:  '',
              meter:  ''
          },
          width: {
              feet:  '',
              meter:  ''
          },
          depth: {
              feet:  '',
              meter:  ''
          },
          draft: {
              feet: '',
              meter: ''
          },
          speed: ''
        },
        powers: [],
        robs: [],
        docs: []
      }
      this.technicalActive.technical_module = true;

        this.formPower.typeOfPower = [
          {
              powerTypeId: null,
              powerSeriesId: null,
              actualRunningHours: null
          }
        ]

      
      let dataAdd = {
          robTypeId: null,
          robSeriesId: null,
          actualRob: null
      }
    this.formROBType.typeOfROB = [dataAdd];

    this.formFileSupportList.fileSupport = [
      {
        fileName: '',
        isUploading: false
      }
    ];
    },
    async saveFleet() {
      this.$swal.fire({
          title: 'Processing...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          onOpen: () => {
            swal.showLoading();
          }
        });

      this.formFleet.horsePower = this.formFleet.horsePower? Number(this.formFleet.horsePower) : null;
      this.formFleet.companyId = this.formFleet.companyId? Number(this.formFleet.companyId) : null;
      this.formFleet.latitude = this.formFleet.latitude? Number(this.formFleet.latitude) : null;
      this.formFleet.longitude = this.formFleet.longitude? Number(this.formFleet.longitude) : null;
      this.formFleet.longitude = this.formFleet.longitude? Number(this.formFleet.longitude) : null;
      this.formPower.typeOfPower.forEach(el => {
        el.powerTypeId = el.powerTypeId ? Number(el.powerTypeId) : null
        el.powerSeriesId = el.powerSeriesId ? Number(el.powerSeriesId) : null
        el.actualRunningHours = el.actualRunningHours ? Number(el.actualRunningHours) : null
      })
      this.formFleet.powers = this.formPower.typeOfPower;
      this.formROBType.typeOfROB.forEach(el => {
        el.robTypeId = el.robTypeId ? Number(el.robTypeId) : null
        el.robSeriesId = el.robSeriesId ? Number(el.robSeriesId) : null
        if(!this.editMode) {
          el.actualRob = el.actualRob ? Number(el.actualRob) : null
        }
      })
      this.formFleet.robs = this.formROBType.typeOfROB;
      if(this.formFileSupportList.fileSupport && this.formFileSupportList.fileSupport[0].fileName) {
        this.formFileSupportList.fileSupport.forEach(el => {
          if(this.editMode) {
            delete el.isUploading
            this.formFleet.docs.push(el)
          } else this.formFleet.docs.push({fileName: el.fileName})
        })
      }
      this.formFleet.deliveryDate = this.formFleet.deliveryDate ? dayjs(this.formFleet.deliveryDate).format('DD-MM-YYYY') : ''

      if(!this.editMode) {
        const res = await this.addFleet(this.formFleet)
        if (res.status == 'success') {
          this.$swal('Add Fleet Success!', res.data.message, 'success')
          this.initFormFleet();
        } else {
          this.$swal(
            `Oops!`,
            res.data.message,
            'error'
          )
        }
      }else{
        const res = await this.updateFleet({id : this.formData.id, payload: this.formFleet})
        if (res.status == 'success') {
          this.$swal('Update Fleet Success!', res.data.message, 'success')
          setTimeout(() => {
            this.cancelFromParent();
          }, 200);
        } else {
          this.$swal(
            `Oops!`,
            res.data.message,
            'error'
          )
        }
      }

    }
  }
}
</script>